import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const cohort_workspaceScreenModule = defineScreen({
  app: "coaching",
  screen_id: "cohort-workspace",
  path: "/cohorts/:cohort_id",
  params: ["cohort_id"],
  heading: { text: "Cohort workspace", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "allow",
    "company_admin": "allow",
    "participant": "allow",
    "cohort_lead": "allow"
  },
  states: ["ready"],
  actions: [
    { id: "load", kind: "secondary", driver: "page.load" }
  ],
  recipe: "Page-1",
  data: { seedNeeds: ["readonly-walk-session"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/cohort-workspace.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default cohort_workspaceScreenModule;
